import { useCallback, useEffect, useState } from "react";
import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, timeAgo } from "@/lib/api";
import { AppShell, Thumb } from "@/components/app/AppShell";

export default function Trash() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/projects/trash").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const restore = async (p) => { await api.post(`/projects/${p.id}/restore`); toast.success("Página restaurada"); load(); };
  const purge = async (p) => {
    if (window.prompt(`Digite EXCLUIR para apagar "${p.name}" permanentemente`) !== "EXCLUIR") return;
    try { await api.delete(`/projects/${p.id}/permanent`); toast.success("Excluída permanentemente"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const empty = async () => {
    if (window.prompt("Digite ESVAZIAR para apagar tudo da lixeira") !== "ESVAZIAR") return;
    await api.delete("/projects/trash"); toast.success("Lixeira esvaziada"); load();
  };
  return (
    <AppShell>
      <div className="flex items-end justify-between gap-6">
        <div><h1 data-testid="trash-title" className="font-display font-bold text-3xl tracking-tight">Lixeira</h1><p className="text-slate-500 mt-1">{items.length} página(s). O slug de uma página apagada fica livre para reuso.</p></div>
        {items.length > 0 && <button data-testid="empty-trash-button" onClick={empty} className="btn btn-ghost !text-red-600"><Trash2 size={15} /> Esvaziar lixeira</button>}
      </div>
      {items.length === 0 ? <div data-testid="trash-empty" className="mt-10 rounded-3xl border border-dashed border-slate-300 p-16 text-center text-slate-500">A lixeira está vazia.</div> : (
        <div className="mt-8 grid sm:grid-cols-2 xl:grid-cols-3 gap-5">
          {items.map((p) => (
            <article key={p.id} data-testid={`trash-item-${p.id}`} className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
              <Thumb html={p.preview} className="aspect-[4/3] [--thumb-scale:0.3] opacity-70" />
              <div className="p-4">
                <h3 className="font-semibold truncate">{p.name}</h3>
                <p className="text-xs text-slate-500">Excluída {timeAgo(p.deleted_at)}</p>
                <div className="mt-3 flex gap-2">
                  <button data-testid={`trash-restore-${p.id}`} onClick={() => restore(p)} className="btn btn-ghost !py-2 !px-3 text-xs flex-1 justify-center"><RotateCcw size={13} /> Restaurar</button>
                  <button data-testid={`trash-purge-${p.id}`} onClick={() => purge(p)} className="btn btn-ghost !py-2 !px-3 text-xs !text-red-600"><Trash2 size={13} /> Excluir</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </AppShell>
  );
}
